import React from "react";
import './ToolList.css';

import palm_count from '../../assets/palm_count.png';
import palm_canopy_size from '../../assets/palm_canopy_size.png';
import palm_distance from '../../assets/palm_distance.png';
import palm_classification from '../../assets/palm_classification.png';

const tools = ['Palm Location', 'Palm Canopy Size', 'Palm Distance', 'Palm Yellowish Classification'];

const toolIcons = {
    'Palm Location': palm_count,
    'Palm Canopy Size': palm_canopy_size,
    'Palm Distance': palm_distance,
    'Palm Yellowish Classification': palm_classification
};

function ToolList({ selectedTool, setSelectedTool }) {
    let rows = [];
    let currentRow = [];

    const handleToolClick = (tool_name) => {
        if (tool_name === 'Palm Location') return; // Prevent unselecting 'Palm Location'
        if (selectedTool.includes(tool_name)) {
            setSelectedTool(selectedTool.filter(tool => tool !== tool_name));
        } else {
            setSelectedTool([...selectedTool, tool_name]);
        }
    }

    tools.slice(1).forEach((tool, index) => { // Start from the second tool
        const isSelected = selectedTool.includes(tool);
        const isLastInRow = (currentRow.length === 2) || (index === tools.length - 2);
        currentRow.push(
            <ToolButton
                key={index}
                name={tool}
                isLastInRow={isLastInRow}
                isSelected={isSelected}
                handleToolClick={handleToolClick}
                icon={toolIcons[tool]}
            />
        );
        if (currentRow.length === 3 || index === tools.length - 2) {
            rows.push(
                <div className="tool__row" key={`row-${index}`}>
                    {currentRow}
                </div>
            );
            currentRow = [];
        }
    });

    return (
        <div className="tool__list__container">
            <div className="tool__section">
                <div className="tool__row tool__row--centered">
                    <ToolButton
                        name="Palm Location"
                        isLastInRow={false}
                        isSelected={true}
                        handleToolClick={handleToolClick}
                        isDisabled={true} // Disable the Palm Location button
                        icon={toolIcons['Palm Location']}
                    />
                </div>
            </div>
            <div className="tool__section">
                <div className="tool__title">Advanced Analysis</div>
                {rows}
            </div>
        </div>
    );
}

const ToolButton = ({ name, isLastInRow, isSelected, handleToolClick, isDisabled, icon }) => {
    const boxStyle = isLastInRow ? {} : { marginRight: '20px' };

    return (
        <div
            className={`tool__button ${isSelected ? "selected" : ""} ${isDisabled ? "disabled" : ""}`}
            onClick={() => handleToolClick(name)}
            style={boxStyle}
        >
            <img src={icon} alt={name} className="tool__button__icon" />
            <span>{name}</span>
        </div>
    );
};

export default ToolList;
